import { createSelector } from 'reselect';
import { getWeekDays } from '../../RosterWeekView';

export const weekDaysNumberSelector = createSelector(
  getWeekDays,
  (weekDays) => weekDays.length
);
